// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"YW-z","inlineTitle":"ZW-z","sponsoredAdsWrapper":"_W-z","marketplaceRecosWrapper":"aX-z"};